// import { useState } from 'react'
// import { Dialog } from '@headlessui/react'
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
// import { FaChevronRight } from "react-icons/fa6";



export default function Hero() {

  return (

    <div className="  ">
      
      <div className="relative isolate px-6   ">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-r from-yellow-300 to-sky-400 opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div className="mx-auto max-w-2xl py-32 ">
          <div className=" mb-8 flex justify-center">
            <div className="relative rounded-full px-3 py-1 text-[2.8vw] sm:text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
            ~ New month, new purchase, free delivery!{' '}
              <a href="#GetYours" className="font-semibold text-indigo-600 capitalize">
                <span className="absolute inset-0 " aria-hidden="true" />
                get yours <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl capitalize">
              get your <div className='bg-yellow- '> <h1>best cube</h1></div> 
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">
            A speed cube is a Rubik's Cube that has been specifically designed to be solved faster, with improved corner cutting and smoother turning.
            </p>
            <div className="mt-10 grid gap-5 md:flex  items-center justify-center gap-x-6">
              <a
                href="/products/1"
                className="rounded-md bg-indigo-600 w-[80vw] md:w-fit px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Get your own
              </a>
              <a href="/new" className=" flex items-center justify-center group/check text-sm  font-semibold leading-6 text-gray-900">
              Check out other cubes
              <span className='group-hover/check:translate-x-1 flex h-2 transition-translate transition duration-200 ' aria-hidden="true">
               <FaChevronRight className='h-3 w-3'/>
              </span>
              </a>
            </div>
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-r from-yellow-300 to-sky-400 opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
      </div>
    </div>
  )
}



const FaChevronRight=({className})=>{
  return(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>);
}